<!-- Avatar column of a received bubble: the avatar on the first of a run, a spacer on the others -->
<ng-template #avatarCol>
  <span *ngIf="!mine && showAvatar" class="chat-msg__avatar" aria-hidden="true">
    <chat-avatar *ngIf="groupStart" [src]="avatarSrc" [name]="avatarLabel" [size]="32"
      [ngbTooltip]="avatarTip || ''" [disableTooltip]="!avatarTip" container="body" placement="top"></chat-avatar>
  </span>
</ng-template>

<!-- Attachments, shared by the text and auto-reply variants -->
<ng-template #attachments>
  <!-- mensagem de voz: o leitor dentro da bolha -->
  <chat-audio-player *ngFor="let f of audios; trackBy: trackByFile" [src]="imageSrc(f)" [duration]="voiceDuration" [mine]="mine && status !== 'failed'"
    [strings]="strings"></chat-audio-player>
  <div *ngIf="images.length > 0" class="chat-msg__images" [class.chat-msg__images--2]="images.length === 2"
    [class.chat-msg__images--3]="images.length === 3" [class.chat-msg__images--many]="images.length >= 4">
    <span *ngFor="let f of images; trackBy: trackByFile" class="chat-msg__img" [class.chat-msg__img--pending]="!f.name">
      <button type="button" class="chat-msg__img-btn" [attr.aria-label]="strings.openImage" [disabled]="!f.name"
        (click)="openImage.emit({ message: message, file: f })">
        <img [appAuthImage]="imageSrc(f)" alt="">
      </button>
      <span *ngIf="!f.name" class="chat-msg__img-spinner" aria-hidden="true"></span>
      <button *ngIf="canDelete && f.id" type="button" class="chat-msg__img-delete" [attr.aria-label]="strings.deleteFile"
        (click)="deleteFile.emit({ message: message, file: f })">
        <chat-icon name="trash" [size]="14"></chat-icon>
      </button>
    </span>
  </div>
  <div *ngIf="pdfs.length > 0" class="chat-msg__files">
    <a *ngFor="let f of pdfs; trackBy: trackByFile" class="chat-msg__pdf" [attr.href]="f.name || null" target="_blank" rel="noopener"
      [attr.aria-label]="strings.openPdf">
      <span class="chat-msg__pdf-icon"><chat-icon name="file" [size]="18"></chat-icon></span>
      <span class="chat-msg__pdf-text">
        <span class="chat-msg__pdf-name">{{ f.originalName || strings.pdf }}</span>
        <span class="chat-msg__pdf-size">{{ strings.pdf }}<ng-container *ngIf="fileSize(f)"> · {{ fileSize(f) }}</ng-container></span>
      </span>
      <chat-icon name="next" [size]="14"></chat-icon>
    </a>
  </div>
</ng-template>

<!-- Delivery state of a sent message (icon swaps with a small pop) -->
<ng-template #stateLine>
  <span *ngIf="showMeta && status !== 'failed'" class="chat-msg__meta">
    <span *ngIf="edited" class="chat-msg__edited">{{ strings.edited }}</span>
    <span *ngIf="time">{{ time }}</span>
    <span *ngIf="status" class="chat-msg__state" [class.chat-msg__state--read]="status === 'read'" [ngSwitch]="status"
      [attr.title]="statusLabel" [attr.aria-label]="statusLabel">
      <chat-icon *ngSwitchCase="'read'" class="chat-msg__state-icon" name="check2" [size]="14"></chat-icon>
      <chat-icon *ngSwitchCase="'delivered'" class="chat-msg__state-icon" name="check" [size]="14"></chat-icon>
      <chat-icon *ngSwitchCase="'sending'" class="chat-msg__state-icon chat-msg__state-icon--spin" name="clock" [size]="13"></chat-icon>
    </span>
  </span>
  <span *ngIf="status === 'failed'" class="chat-msg__failed" role="status">
    {{ strings.failed }}
    <button type="button" class="chat-msg__retry" (click)="retry.emit(message)">
      <chat-icon name="retry" [size]="13"></chat-icon>
      {{ strings.retry }}
    </button>
  </span>
</ng-template>

<!-- Hover / focus actions (always visible on touch) -->
<!-- Secção 10: a mensagem citada por esta resposta (clicar leva até ela) -->
<ng-template #quoteBlock>
  <button *ngIf="quote" type="button" class="chat-msg__quote" [class.chat-msg__quote--deleted]="quote.deleted"
    [attr.aria-label]="strings.replyQuoteHint + ': ' + quote.name" (click)="jumpTo.emit(quote.messageId)">
    <span class="chat-msg__quote-name">{{ quote.name }}</span>
    <span class="chat-msg__quote-text">{{ quote.text }}</span>
  </button>
</ng-template>

<!-- Secção 12: as reações da mensagem, por baixo da bolha; clicar junta-se ou tira a própria -->
<ng-template #reactionsRow>
  <div *ngIf="reactions.length > 0" class="chat-msg__reactions" [class.chat-msg__reactions--out]="mine">
    <button *ngFor="let g of reactions; trackBy: trackByReaction" type="button" class="chat-msg__reaction" [class.chat-msg__reaction--mine]="isMyReaction(g)"
      [disabled]="!reactable" [attr.aria-label]="g.emoji + ' ' + g.count" (click)="onReactionChip(g, $event)">
      <span class="chat-msg__reaction-emoji">{{ g.emoji }}</span><span *ngIf="g.count > 1" class="chat-msg__reaction-count">{{ g.count }}</span>
    </button>
  </div>
</ng-template>

<ng-template #actions>
  <span *ngIf="canDelete || canEdit || replyable || reactable" class="chat-msg__actions">
    <span *ngIf="reactable" class="chat-msg__react-anchor">
      <button type="button" class="chat-msg__action" [class.chat-msg__action--on]="reactOpen" [attr.aria-label]="strings.react" [ngbTooltip]="strings.react"
        container="body" [attr.aria-expanded]="reactOpen" (click)="toggleReactPicker($event)">
        <chat-icon name="smile" [size]="15"></chat-icon>
      </button>
      <span *ngIf="reactOpen" class="chat-msg__react" role="menu" (click)="$event.stopPropagation()">
        <button *ngFor="let e of quickEmojis" type="button" role="menuitem" class="chat-msg__react-item" [class.chat-msg__react-item--on]="myReaction === e"
          (click)="pickReaction(e, $event)">{{ e }}</button>
      </span>
    </span>
    <button *ngIf="replyable" type="button" class="chat-msg__action" [attr.aria-label]="strings.reply" [ngbTooltip]="strings.reply"
      container="body" (click)="reply.emit(message)">
      <chat-icon name="reply" [size]="15"></chat-icon>
    </button>
    <button *ngIf="canEdit" type="button" class="chat-msg__action" [attr.aria-label]="strings.editMessage" [ngbTooltip]="strings.editMessage"
      container="body" (click)="editMessage.emit(message)">
      <chat-icon name="edit" [size]="15"></chat-icon>
    </button>
    <button *ngIf="canDelete" type="button" class="chat-msg__action chat-msg__action--danger" [attr.aria-label]="strings.deleteMessage" [ngbTooltip]="strings.deleteMessage"
      container="body" (click)="deleteMessage.emit(message)">
      <chat-icon name="trash" [size]="15"></chat-icon>
    </button>
  </span>
</ng-template>

<!-- Secção 10: o ícone que aparece à esquerda enquanto se arrasta para responder -->
<span *ngIf="replyable" class="chat-msg__swipe" aria-hidden="true"><chat-icon name="reply" [size]="16"></chat-icon></span>

<ng-container [ngSwitch]="deleted ? 'deleted' : kind">

  <!-- secção 9: apagada para todos (como no WhatsApp): só o aviso, do lado de quem a enviou -->
  <div *ngSwitchCase="'deleted'" class="chat-msg" [class.chat-msg--out]="mine" [class.chat-msg--in]="!mine"
    [class.chat-msg--start]="groupStart" [class.chat-msg--end]="groupEnd">
    <ng-container *ngTemplateOutlet="avatarCol"></ng-container>
    <div class="chat-msg__col">
      <div *ngIf="author" class="chat-msg__author">{{ author }}</div>
      <div class="chat-msg__bubble chat-msg__bubble--deleted">
        <span class="chat-msg__deleted"><chat-icon name="ban" [size]="14"></chat-icon>{{ deletedText }}</span>
      </div>
      <span *ngIf="showMeta" class="chat-msg__meta">{{ time }}</span>
    </div>
  </div>

  <!-- system line: centered grey pill, text built from `code` -->
  <div *ngSwitchCase="'system'" class="chat-msg chat-msg--system">
    <span class="chat-msg__system">
      <chat-icon [name]="$any(systemIcon)" [size]="12"></chat-icon>
      <span>{{ systemText }}</span><span *ngIf="time" class="chat-msg__system-time">· {{ time }}</span>
    </span>
  </div>

  <!-- internal note: centered amber box -->
  <div *ngSwitchCase="'note'" class="chat-msg chat-msg--note" [class.chat-msg--failed]="status === 'failed'">
    <div class="chat-msg__note">
      <span class="chat-msg__note-icon"><chat-icon name="note" [size]="15"></chat-icon></span>
      <div class="chat-msg__note-body">
        <div class="chat-msg__note-title">{{ strings.noteVisibility }}</div>
        <ng-container *ngTemplateOutlet="quoteBlock"></ng-container>
        <div class="chat-msg__note-text"><ng-container *ngFor="let p of noteParts"><span *ngIf="p.mention" class="chat-msg__mention">@{{ p.text }}</span><ng-container *ngIf="!p.mention">{{ p.text }}</ng-container></ng-container></div>
        <ng-container *ngTemplateOutlet="reactionsRow"></ng-container>
        <div *ngIf="showMeta && status !== 'failed'" class="chat-msg__note-meta">
          <ng-container *ngIf="message.userSender?.name">{{ strings.noteAddedBy.replace('{name}', message.userSender?.name || '') }} · </ng-container><ng-container *ngIf="edited">{{ strings.edited }} · </ng-container>{{ time }}
          <span *ngIf="status === 'sending'" class="chat-msg__state">
            <chat-icon class="chat-msg__state-icon chat-msg__state-icon--spin" name="clock" [size]="12"></chat-icon>{{ statusLabel }}
          </span>
        </div>
        <span *ngIf="status === 'failed'" class="chat-msg__failed" role="status">
          {{ strings.failed }}
          <button type="button" class="chat-msg__retry" (click)="retry.emit(message)">
            <chat-icon name="retry" [size]="13"></chat-icon>
            {{ strings.retry }}
          </button>
        </span>
      </div>
      <ng-container *ngTemplateOutlet="actions"></ng-container>
    </div>
  </div>

  <!-- automatic reply -->
  <div *ngSwitchCase="'auto_reply'" class="chat-msg chat-msg--in" [class.chat-msg--start]="groupStart" [class.chat-msg--end]="groupEnd">
    <ng-container *ngTemplateOutlet="avatarCol"></ng-container>
    <div class="chat-msg__col">
      <div class="chat-msg__bubble chat-msg__bubble--in chat-msg__bubble--auto">
        <div class="chat-msg__tag chat-msg__tag--auto"><chat-icon name="bolt" [size]="12"></chat-icon>{{ strings.autoReply }}</div>
        <div *ngIf="text" class="chat-msg__text">{{ text }}</div>
        <ng-container *ngTemplateOutlet="attachments"></ng-container>
      </div>
      <span *ngIf="showMeta" class="chat-msg__meta">{{ time }}</span>
    </div>
  </div>

  <!-- property card as a bubble -->
  <div *ngSwitchCase="'property'" class="chat-msg" [class.chat-msg--out]="mine" [class.chat-msg--in]="!mine"
    [class.chat-msg--start]="groupStart" [class.chat-msg--end]="groupEnd" [class.chat-msg--failed]="status === 'failed'">
    <ng-container *ngTemplateOutlet="avatarCol"></ng-container>
    <div class="chat-msg__col chat-msg__col--card">
      <div *ngIf="author" class="chat-msg__author">{{ author }}</div>
      <div *ngIf="text" class="chat-msg__bubble" [class.chat-msg__bubble--out]="mine" [class.chat-msg__bubble--in]="!mine">
        <div class="chat-msg__text">{{ text }}</div>
      </div>
      <chat-property-card *ngIf="message.property" class="chat-msg__card" [class.chat-msg__card--pending]="status === 'sending'"
        [class.chat-msg__card--out]="mine" [property]="message.property!" [canScheduleVisit]="canManageVisits && status !== 'sending'"
        [strings]="strings" (scheduleVisit)="emitVisit('schedule')"></chat-property-card>
      <ng-container *ngTemplateOutlet="reactionsRow"></ng-container>
      <ng-container *ngIf="mine; else timeOnly"><ng-container *ngTemplateOutlet="stateLine"></ng-container></ng-container>
      <ng-template #timeOnly><span *ngIf="showMeta" class="chat-msg__meta">{{ time }}</span></ng-template>
    </div>
    <ng-container *ngTemplateOutlet="actions"></ng-container>
  </div>

  <!-- 7.2: pedido de disponibilidade -->
  <div *ngSwitchCase="'visit_request'" class="chat-msg" [class.chat-msg--out]="mine" [class.chat-msg--in]="!mine"
    [class.chat-msg--start]="groupStart" [class.chat-msg--end]="groupEnd">
    <ng-container *ngTemplateOutlet="avatarCol"></ng-container>
    <div class="chat-msg__col chat-msg__col--card">
      <div *ngIf="author" class="chat-msg__author">{{ author }}</div>
      <!-- No CRM o consultor não responde pelo cliente (canAnswer): marca com um clique o que o cliente escolheu / propôs. -->
      <chat-visit-request-card class="chat-msg__card" [class.chat-msg__card--out]="mine" [params]="message.params || {}" [mine]="mine"
        [canAnswer]="false" [canSchedule]="canManageVisits" [busy]="!!actionBusy && actionBusy === message.messageId" [strings]="strings"
        (choose)="emitVisit('choose', $event)" (propose)="emitVisit('propose', $event)" (decline)="emitVisit('decline')"
        (schedule)="emitVisit('schedule', $event)" (proposeOther)="emitVisit('proposeOther')"></chat-visit-request-card>
      <span *ngIf="showMeta" class="chat-msg__meta">{{ time }}</span>
    </div>
  </div>

  <!-- 7.2: visita marcada -->
  <div *ngSwitchCase="'visit'" class="chat-msg" [class.chat-msg--out]="mine" [class.chat-msg--in]="!mine"
    [class.chat-msg--start]="groupStart" [class.chat-msg--end]="groupEnd">
    <ng-container *ngTemplateOutlet="avatarCol"></ng-container>
    <div class="chat-msg__col chat-msg__col--card">
      <div *ngIf="author" class="chat-msg__author">{{ author }}</div>
      <chat-visit-card class="chat-msg__card" [class.chat-msg__card--out]="mine" [params]="message.params || {}" [canManage]="canManageVisits"
        [strings]="strings" (cancel)="emitVisit('cancel')" (ics)="emitVisit('ics')" (requestForm)="emitVisit('requestForm')"
        (reschedule)="emitVisit('reschedule')"></chat-visit-card>
      <span *ngIf="showMeta" class="chat-msg__meta">{{ time }}</span>
    </div>
  </div>

  <!-- 7.2: ficha de visita virtual -->
  <div *ngSwitchCase="'visit_form'" class="chat-msg" [class.chat-msg--out]="mine" [class.chat-msg--in]="!mine"
    [class.chat-msg--start]="groupStart" [class.chat-msg--end]="groupEnd">
    <ng-container *ngTemplateOutlet="avatarCol"></ng-container>
    <div class="chat-msg__col chat-msg__col--card">
      <div *ngIf="author" class="chat-msg__author">{{ author }}</div>
      <chat-visit-form-card class="chat-msg__card" [class.chat-msg__card--out]="mine" [params]="message.params || {}" [canManage]="canManageVisits"
        [strings]="strings" (copy)="emitVisit('copyForm')"></chat-visit-form-card>
      <span *ngIf="showMeta" class="chat-msg__meta">{{ time }}</span>
    </div>
  </div>

  <!-- 7.2: qualificação -->
  <div *ngSwitchCase="'qualification'" class="chat-msg" [class.chat-msg--out]="mine" [class.chat-msg--in]="!mine"
    [class.chat-msg--start]="groupStart" [class.chat-msg--end]="groupEnd">
    <ng-container *ngTemplateOutlet="avatarCol"></ng-container>
    <div class="chat-msg__col chat-msg__col--card">
      <div *ngIf="author" class="chat-msg__author">{{ author }}</div>
      <chat-qualification-card class="chat-msg__card" [class.chat-msg__card--out]="mine" [params]="message.params || {}" [canManage]="canQualify"
        [strings]="strings" (edit)="emitCard('editQualification')" (search)="emitCard('searchProperties')"></chat-qualification-card>
      <span *ngIf="showMeta" class="chat-msg__meta">{{ time }}</span>
    </div>
  </div>

  <!-- 7.2: proposta -->
  <div *ngSwitchCase="'proposal'" class="chat-msg" [class.chat-msg--out]="mine" [class.chat-msg--in]="!mine"
    [class.chat-msg--start]="groupStart" [class.chat-msg--end]="groupEnd">
    <ng-container *ngTemplateOutlet="avatarCol"></ng-container>
    <div class="chat-msg__col chat-msg__col--card">
      <div *ngIf="author" class="chat-msg__author">{{ author }}</div>
      <chat-proposal-card class="chat-msg__card" [class.chat-msg__card--out]="mine" [params]="message.params || {}" [canManage]="canManageVisits"
        [dealId]="dealId" [strings]="strings"></chat-proposal-card>
      <span *ngIf="showMeta" class="chat-msg__meta">{{ time }}</span>
    </div>
  </div>

  <!-- text (default) -->
  <div *ngSwitchDefault class="chat-msg" [class.chat-msg--out]="mine" [class.chat-msg--in]="!mine"
    [class.chat-msg--start]="groupStart" [class.chat-msg--end]="groupEnd" [class.chat-msg--failed]="status === 'failed'">
    <ng-container *ngTemplateOutlet="avatarCol"></ng-container>
    <div class="chat-msg__col">
      <div *ngIf="author" class="chat-msg__author">{{ author }}</div>
      <div class="chat-msg__bubble" [class.chat-msg__bubble--out]="mine && status !== 'failed'" [class.chat-msg__bubble--in]="!mine"
        [class.chat-msg__bubble--failed]="mine && status === 'failed'" [class.chat-msg__bubble--media]="!text && images.length > 0 && !quote">
        <ng-container *ngTemplateOutlet="quoteBlock"></ng-container>
        <div *ngIf="text" class="chat-msg__text">{{ text }}</div>
        <ng-container *ngTemplateOutlet="attachments"></ng-container>
      </div>
      <ng-container *ngTemplateOutlet="reactionsRow"></ng-container>
      <ng-container *ngIf="mine; else timeOnlyText"><ng-container *ngTemplateOutlet="stateLine"></ng-container></ng-container>
      <ng-template #timeOnlyText><span *ngIf="showMeta" class="chat-msg__meta"><span *ngIf="edited" class="chat-msg__edited">{{ strings.edited }}</span>{{ time }}</span></ng-template>
    </div>
    <ng-container *ngTemplateOutlet="actions"></ng-container>
  </div>

</ng-container>
